<template>
		<div class="knd-button-wrapper">
				<p class="knd-button-next">Zoek je buurt</p>

			<div class="knd-button-container knd-search-container">

				<div class='knd-input__container knd-input__container__white'>
					<input 
						class='knd-search__input knd-input-gemeente' 
						ref='inputgemeente' 
						placeholder="selecteer een gemeente" />
						
						<img 
						class="knd-button-icon" 
						ref="inputGemeenteButton"
						:src="require('@/assets/icons/pijl.svg')" 
						alt="" />
				</div>

				<div class='knd-input__container knd-input__container__white'>
					<input 
						class='knd-search__input knd-input-buurt' 
						ref='inputBuurt'
						placeholder="selecteer een buurt" />

						<img 
						class="knd-button-icon" 
						ref="inputBuurtButton"
						:src="require('@/assets/icons/pijl.svg')" 
						alt="" />
				</div>
			</div>
		</div>
</template>

<script>
	import * as Awesomplete from 'awesomplete';
	import 'awesomplete/awesomplete.css';

	import './index.scss';

export default {

	name: 'index',

	data () {
		return {
		locatorText: "we slaan geen gegevens op",
		content: this.$store.state.content,
		gemeenteAlle: this.$store.state.kaart.gemeenten,
		buurtAlle: null,
		notSharedYet: true,
		first: true
		}
	},
	computed: {
		buurtSelected () {
			return this.$store.getters.buurtSelected;
		},

		gemeenteSelected () {
			return this.$store.getters.gemeenteSelected;
		},
	},  
	mounted: function() {
		this.renderAutoCompleteGemeente();
	},
	watch: {
		gemeenteSelected: { 
			handler(value) {
				this.buurtAlle = value.buurten;
				if(!this.buurtAlle) return;
				this.$refs.inputgemeente.placeholder = value["GM_NAAM"];
				this.$refs.inputBuurt.placeholder = '';

				if(!this.first) {
					this.updateBuurten();
					return;
				}

				this.renderAutoCompleteBuurten();
				this.first = false;
			}, 
			deep: true
		},

		buurtSelected: {
			handler(value) {
				this.locatorText = this.buurtSelected.buurt_naam + ", " + this.gemeenteSelected.gemeente_naam;
				this.$refs.inputBuurt.placeholder = value.properties["BU_NAAM"];    
			},
			deep: true
		}
	},	
	methods: {
		sort(a, b) {
			return String(a.label).localeCompare(String(b.label));
		},

		renderAutoCompleteGemeente() {
			var input = this.$refs.inputgemeente;
			var inputButton = this.$refs.inputGemeenteButton;
			let data = this.$store.state.gemeentenAutocomplete;

			this.inputGemeenten = new Awesomplete(input, {
				list: data,
				minChars: 0,
				maxItems: data.length,
				sort: this.sort,
				replace: (suggestion) => {
					input.value = suggestion.label;

					let gemeente = data[+suggestion.value];						
					this.$refs.inputBuurt.value = '';

					this.$store.dispatch('loadGemeente', gemeente.code).then(d => {
						this.$refs.inputgemeente.placeholder = this.$refs.inputgemeente.value;
						this.$refs.inputgemeente.value = '';
						this.$refs.inputgemeente.blur();

						this.inputBuurten.placeholder = '';
						this.inputBuurten.evaluate();
					})
				}         
			});

			const listeners = [input, inputButton];

			listeners.forEach((listener) => {
				listener.addEventListener("click", () => {
					if (this.inputGemeenten.ul.childNodes.length === 0) {
						this.inputGemeenten.minChars = 0;
						this.inputGemeenten.evaluate();
					}
					else if (this.inputBuurten?.ul?.hasAttribute('hidden')) {
						this.inputGemeenten.evaluate();
						this.inputGemeenten.open();
					}
					else {
						this.inputGemeenten.close();
					}
				});
			});

		},

		renderAutoCompleteBuurten() {
			var input = this.$refs.inputBuurt;
			var inputButton = this.$refs.inputBuurtButton;

			let data = this.buurtAlle.map((d, index) => {
				if (d.properties["BU_NAAM"] !== "") {
					return {label: d.properties["BU_NAAM"], value: index}
				}
			});

			this.inputBuurten = new Awesomplete(input, {
				list: data,
				sort: this.sort,
				maxItems: data.length,
				minChars: 0,
				replace: (suggestion) => {
					input.value = '';
					input.blur();

					let buurt = this.buurtAlle[+suggestion.value];
					this.$store.dispatch('updateBuurt', buurt);
				}     
			});
				
			const listeners = [input, inputButton];

			listeners.forEach((listener) => {
				listener.addEventListener("click", () => {
					if (this.inputBuurten.ul.childNodes.length === 0) {
						this.inputBuurten.minChars = 0;
						this.inputBuurten.evaluate();
					}
					else if (this.inputBuurten?.ul?.hasAttribute('hidden')) {
						this.inputBuurten.evaluate();
						this.inputBuurten.open();
					}
					else {
						this.inputBuurten.close();
					}
				});
			});
		},

		updateBuurten() {

			let data = this.buurtAlle.map((d, index) => {
				if (d.properties["BU_NAAM"] !== "") {
					return {label: d.properties["BU_NAAM"], value: index}
				}
			});

			this.inputBuurten.placeholder = '';
			this.inputBuurten.list = data;
			this.inputBuurten.maxItems = data.length;

			// this.inputBuurten.evaluate();
			// if(this.$refs.inputBuurt.value) return;
			// this.inputBuurten.open();
		},
	}
}
</script>

<style lang="css" scoped>
</style>